// JavaScript to toggle visibility of the mobile search icon on scroll
window.addEventListener('scroll', function() {
  // Check if the viewport width is 768px or less (mobile devices)
  if (window.innerWidth <= 768) { // Adjust the breakpoint if needed
    const searchIcon = document.getElementById('mobile-search-icon-hidden');
    
    // Ensure the element exists
    if (searchIcon) {
      if (window.scrollY > 0) {
        searchIcon.style.visibility = 'visible';
      } else {
        searchIcon.style.visibility = 'hidden';
      }
    }
  }
});
